import { gql } from '@apollo/client'

export default gql`
  subscription GetReadingRoomBookParticipants($reading_id: uuid!) {
    view_reading_room_book(where: { reading_id: { _eq: $reading_id } }) {
      reading_id
      user_id
      person_name
      reading {
        readingevents {
          readingstate {
            name
            created
          }
        }
      }
    }
  }
`
